import { useState, useCallback } from 'react';
import { j209Api, FJ180 } from '../../../services/j209Api';

export function useLookupNames() {
  const [names, setNames] = useState<Record<string, string>>({});

  const resolveAllNames = useCallback(async (data: Partial<FJ180>) => {
    const entries: [string, string, string][] = [
      ['warehouse', 'warehouse', data.fj180_15 || ''],
      ['employee', 'employee', data.fj180_17 || ''],
      ['department', 'department', data.fj180_16 || ''],
    ];
    const results = await Promise.all(
      entries.map(([key, type, code]) =>
        j209Api.lookupName(type, code).then(name => [key, name] as [string, string])
      )
    );
    setNames(prev => {
      const next = { ...prev };
      for (const [key, name] of results) next[key] = name;
      return next;
    });
  }, []);

  const resolveSingleName = useCallback(async (nameKey: string, type: string, code: string) => {
    const name = await j209Api.lookupName(type, code);
    setNames(prev => ({ ...prev, [nameKey]: name }));
  }, []);

  const clearNames = useCallback(() => {
    setNames({});
  }, []);

  return { names, resolveAllNames, resolveSingleName, clearNames };
}
